import { inject, observer } from 'mobx-react';
import { useEffect } from 'react';
import { useTranslation } from '../t';
import C from '../colors';

const icons = {
  success: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="m5 13 4 4L19 7"/>
    </svg>
  ),
  error: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><path d="m15 9-6 6M9 9l6 6"/>
    </svg>
  ),
  warning: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 9v4M12 17h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    </svg>
  ),
  info: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/>
    </svg>
  ),
};

const configs = {
  success: { bg: '#E3F0E6', fg: '#2A5A3A', border: '#B8D8C0', icon: 'success' },
  error:   { bg: '#FBE0E0', fg: '#8C2020', border: '#F0C0C0', icon: 'error' },
  warning: { bg: '#FFF1E0', fg: '#7A4A1A', border: '#F5D5B0', icon: 'warning' },
  info:    { bg: '#E5EDF5', fg: '#2A4A6A', border: '#C0D0E5', icon: 'info' },
};

const AppSnackbar = inject('snackbarStore')(observer(({ snackbarStore }) => {
  const { t } = useTranslation();
  const open = snackbarStore.open;
  const sev = snackbarStore.severity || 'info';
  const cfg = configs[sev] || configs.info;

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => snackbarStore.closeSnackbar(), 3000);
      return () => clearTimeout(timer);
    }
  }, [open, snackbarStore]);

  return (
    <div style={{
      position: 'fixed', top: 20, right: 20, zIndex: 9999,
      transform: open ? 'translateX(0)' : 'translateX(calc(100% + 24px))',
      opacity: open ? 1 : 0,
      transition: 'transform .35s cubic-bezier(.4,0,.2,1), opacity .25s',
      pointerEvents: open ? 'auto' : 'none',
      maxWidth: 400,
    }}>
      <div style={{
        display: 'flex', alignItems: 'flex-start', gap: 10,
        padding: '14px 16px',
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
        borderRadius: 12,
        boxShadow: '0 8px 32px -10px rgba(0,0,0,.15)',
        backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
      }}>
        <span style={{ color: cfg.fg, flexShrink: 0, marginTop: 1 }}>{icons[cfg.icon]}</span>
        <div style={{ flex: 1, minWidth: 0, fontSize: 13, fontFamily: C.sans, color: cfg.fg, lineHeight: 1.5 }}>
          {snackbarStore.message && t(snackbarStore.message)}
        </div>
        <button onClick={snackbarStore.closeSnackbar} style={{
          background: 'none', border: 'none', cursor: 'pointer', padding: 0,
          color: cfg.fg, opacity: 0.5, fontSize: 16, lineHeight: 1, flexShrink: 0,
        }}>×</button>
      </div>
    </div>
  );
}));

export default AppSnackbar;
